<template>
  <component
    :is="isLink ? 'ActionableLink' : 'div'"
    :class="iconComponent ? params.classes : ''"
    class="d-contents"
    :to="params.to"
    :on-click="linkClickHandler"
  >
    <span v-if="iconComponent" class="d-contents" @click="iconClickHandler">
      <component :is="iconComponent" :class="params.classes" />
    </span>

    <template v-else-if="hasValue">
      <v-icon
        v-if="!params.isLoading"
        :class="params.classes"
        :disabled="params.isDisabled"
        :size="iconSize"
        :color="params.color"
        >{{ iconValue }}</v-icon
      >

      <v-progress-circular
        v-if="params.isLoading"
        color="primary"
        class="progress-circular"
        indeterminate
        :size="20"
        :width="2"
      />
    </template>
  </component>
</template>

<script>
import { has, isEmpty, get, startsWith } from 'lodash';

export default {
  computed: {
    iconComponent() {
      return get(this.params, 'iconComponent', null);
    },

    iconValue() {
      // This didn't handle mdi icons. If it's mdi, use as-is, otherwise prepend $
      const iconName = this.params.value;
      return startsWith(iconName, 'mdi-') ? iconName : `$${iconName}`;
    },

    iconSize() {
      return get(this.params, 'size', 18);
    },

    isLink() {
      return has(this.params, 'to');
    },

    hasOnClick() {
      return has(this.params, 'onClick');
    },

    hasValue() {
      return !isEmpty(this.params.value);
    },
  },

  methods: {
    linkClickHandler() {
      return !this.params.isDisabled && this.isLink && this.hasOnClick
        ? this.params.onClick(this.params.data)
        : () => {};
    },

    iconClickHandler() {
      return !this.params.isDisabled && !this.isLink && this.hasOnClick
        ? this.params.onClick(this.params.clickParams)
        : () => {};
    },
  },
};
</script>
